import env from 'config/env'

export const PICKUP_HOW_IT_WORKS = Object.freeze({
  banner: [
    {
      ratio: 0.75,
      src: `${env.IMG_HOST}img/pickup/hiw_banner_wm.jpg`,
    },
    {
      ratio: 1,
      src: `${env.IMG_HOST}img/pickup/hiw_banner_w.jpg`,
    },
  ],
  content: [
    {
      title: 'Tap.',
      titleKey: 'PICKUP_HOW_IT_WORKS_TAP',
      desc: 'to pick your favourite items on the Pomelo app',
      descKey: 'PICKUP_HOW_IT_WORKS_DESC_1',
    },
    {
      title: 'Try.',
      titleKey: 'PICKUP_HOW_IT_WORKS_TRY',
      desc: 'at a Pomelo location of your choice.',
      descKey: 'PICKUP_HOW_IT_WORKS_DESC_2',
    },
    {
      title: 'Buy.',
      titleKey: 'PICKUP_HOW_IT_WORKS_BUY',
      desc: 'only the items you love. Skip the hassle of the returns!',
      descKey: 'PICKUP_HOW_IT_WORKS_DESC_3',
    },
  ],
})

export const PICKUP_LOCATION = Object.freeze({
  call: 'call us',
  closest: 'closest station',
  contact: 'contact us',
  getDirection: 'Get Direction',
  hours: 'hours',
  location: 'location',
  callKey: 'PICKUP_LOCATION_CALL',
  closestKey: 'PICKUP_LOCATION_CLOSEST',
  contactKey: 'PICKUP_LOCATION_CONTACT',
  getDirectionKey: 'PICKUP_LOCATION_GET_DIRECTION',
  hoursKey: 'PICKUP_LOCATION_HOURS',
  locationKey: 'PICKUP_LOCATION_LOCATION',
})
